import { HttpHeaders, HttpParams, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IRetornoBuscaCEPModel } from '../model/buscaCEP.model';
import { LoginModel } from '../model/login.model';
import { IConsultaMunicipioModel } from '../model/municipio.model';
import { LocalStorageService } from './localstorage.service';
import { SnackBarService } from './snack-bar-service.service';
import { CONFIG_URLS_API } from 'src/environments/config-envs';

@Injectable({
  providedIn: 'root'
})
export class CorporativoService {

  public usuario!: LoginModel;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient, 
      private localStorageService: LocalStorageService,
      private snackBar: SnackBarService) { 

    var userData = this.localStorageService.getItem('userData');

    if (userData != null) {
      this.usuario = JSON.parse(userData);
    }
  }

  consultaMunicipios(uf: string) : Observable<IConsultaMunicipioModel>{
    
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_ConsultaMunicipios + '/' +  this.usuario.retorno.guid + '/' + uf ;

    return this.http.get<IConsultaMunicipioModel>(url, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível consultar as Cidades.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IConsultaMunicipioModel>('Não foi possível consultar as Cidades.', {sucesso : false, retorno: [], mensagens: []}))
    );
  }

  private handleError<T>(mensagem = 'Não foi possível realizar a operação.', result?: T) {
    return (error: any): Observable<T> => {

      this.snackBar.flashMessage(mensagem, ['snackbar-error'], 'Fechar', 0);

      return of(result as T);
    };
  }
}
